export default __webpack_public_path__ + "static/media/img-ovato-dao.2386c9d9.png";